import { IconDotsVertical, IconEdit, IconFolder, IconTrash } from "@tabler/icons";
import axios from "axios";
import { useState } from "react";
import { Dropdown } from "../../Dropdown";
import Input from "./Input";

const Folder = ({ id, name, siteId, setCurrentFolderId, currentFolderId, refetch }: { id: number, name: string, siteId: number, setCurrentFolderId: Function, currentFolderId?: number, refetch: Function }) => {
  const [isEditing, setIsEditing] = useState(false)

  return (
    <div key={id} className={`flex items-center py-[6px] px-4 mx-2 rounded cursor-pointer ${currentFolderId === id && 'bg-primary-lighter text-primary'} ${!isEditing && 'hover:bg-primary-lighter hover:text-primary'}`} onClick={() => setCurrentFolderId(id)} >
      <IconFolder size={24} stroke={1.25} />
      {
        isEditing ? (
          <Input id={id} name={name} setIsEditing={setIsEditing} />
        ) :
          (
            <>
              <div className='ml-2 mr-auto font-light w-[150px] truncate'>
                <span>{name}</span>
              </div>
              <Dropdown
                component={<IconDotsVertical fill='black' className='mt-1' stroke={1.25} />}
                action="primary"
                options={[
                  { value: 'rename', label: 'Rename', icon: <IconEdit stroke={1.5} size="20px" /> },
                  { value: 'delete', label: 'Delete', icon: <IconTrash stroke={1.5} size="20px" /> },
                ]}
                callback={async ({ value, label }: { value: string, label: string }) => {
                  if (value === 'delete') {
                    const res = await axios.post(`//${window.appDomain}/attachments/update_folder?site_id=${siteId}&folder_id=${id}&token=${window.token}`);
                    if(res.status === 200) refetch();
                    setCurrentFolderId(null)
                  } else if (value === 'rename') {
                    setIsEditing(true)
                  }
                }}
                value='edit'
                noWidth={true}
                alignLeft={true}
                width='w-[120px]'
                // autoAdjustBottom={false}
                // alignTop={true}
                offsetHeight={window.innerHeight > 900 ? 600 : window.innerHeight > 700 ? 500 : 400}
              />
            </>
          )
      }
    </div>
  )
};

export default Folder;